const DiceData = {
	diceValue: 1,
	isLocked: false,
};

export default DiceData;
